// extracted by mini-css-extract-plugin
export default {"heading":"PrivacyPolicyPage_heading__-L1Hd","content":"PrivacyPolicyPage_content__e3H11"};